import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FuldmagtChoiceService } from 'src/app/projekter/fuldmagt-choice.service';

@Injectable()
export class FuldmagtHttpInterceptor implements HttpInterceptor {
  constructor(private fuldmagtChoiceService: FuldmagtChoiceService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const fuldmagtChoice = this.fuldmagtChoiceService.getChoice();

    if (fuldmagtChoice && fuldmagtChoice !== 'self') {
      request = request.clone({
        setHeaders: {
          [this.fuldmagtChoiceService.key]: fuldmagtChoice,
        },
      });
    }
    return next.handle(request);
  }
}
